// import { expandUrl, createFromTemplates, createFromTemplate } from 'ol/tileurlfunction'
import { createTileUrlFunction } from 'ol-tilecache'
import {
  CACHE_SIZE,
  EPSG_3857,
  MAX_ZOOM,
  MIN_ZOOM,
  REPROJ_ERR_THRESHOLD,
  TILE_SIZE,
  PIXEL_RATIO,
} from '../../utils/consts'
import { createExtentFromProjection } from '../../utils/extent'
import { createXyzGrid } from '../../utils/tilegrid'
// import { hasView } from '../util/assert'
// import { _.replaceTokens, isFunction, _.isString, _.pick } from '../util/minilo'
import timeEnabled from './time-enabled.js';

import source from './source'

const props = {
  cacheSize: {
    type: Number,
    default: CACHE_SIZE,
  },
  crossOrigin: String,
  maxZoom: {
    type: Number,
    default: MAX_ZOOM,
  },
  minZoom: {
    type: Number,
    default: MIN_ZOOM,
  },
  opaque: Boolean,
  projection: {
    type: String,
    default: EPSG_3857,
  },
  reprojectionErrorThreshold: {
    type: Number,
    default: REPROJ_ERR_THRESHOLD,
  },
  tilePixelRatio: {
    type: Number,
    default: PIXEL_RATIO,
  },
  tileSize: {
    type: Array,
    default: () => [TILE_SIZE, TILE_SIZE],
    validator: value => value.length === 2,
  },
  tileLoadFunction: Function,
  url: {
    type: [String, Function],
    required: true,
  },
  /**
   * Duration of the opacity transition for rendering. To disable the opacity transition, pass `0`.
   * @type {number}
   */
  transition: Number,
}

const computed = {
  /**
   * @type {string}
   */
  urlTmpl () {
    if (!_.isString(this.url)) {
      return ''
    }

    return this.replaceTokens(this.url, _.pick(this, this.urlTokens))
  },
  urlTokens () { return [] },
}

const methods = {
  /**
   * @return {ol.tilegrid.TileGrid}
   * @protected
   */
  createTileGrid () {
    // hasView(this)
    
    return createXyzGrid({
      extent: createExtentFromProjection(this.$view.getProjection()),
      maxZoom: this.maxZoom,
      minZoom: this.minZoom,
      tileSize: this.tileSize,
    })
  },
  /**
   * @return {ol.TileUrlFunction}
   * @protected
   */
  createUrlFunc () {
    // custom url function provided
    if (_.isFunction(this.url)) {
      return this.url
    }
    // hasView(this)
    // or use url function from ol-tilecache
    
    return createFromTemplate(
		expandUrl(this.urlTmpl),
		this._tileGrid
    )
    // let tiler = createTileUrlFunction(
    //   this.urlTmpl,
    //   this._tileGrid,
    //   createExtentFromProjection(this.$view.getProjection()),
    // )
    // console.log(tiler)
    // return tiler
  },
  /**
   * @return {Promise}
   * @protected
   */
  init () {
    /**
     * @type {ol.tilegrid.TileGrid}
     * @protected
     */
    
    this._tileGrid = this.createTileGrid()
    // console.log("Init tile-source.js")
    return source.methods.init.call(this)
  },
  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit () {
    this._tileGrid = undefined

    return source.methods.deinit.call(this)
  },
  /**
   * @return {void}
   * @protected
   */
  mount () {
    source.methods.mount.call(this)
  },
  /**
   * @return {void}
   * @protected
   */
  unmount () {
    source.methods.mount.call(this)
  },

  replaceTokens (string, replaces) {
	  const regExp = new RegExp(Object.keys(replaces).map(field => '(\\{' + field + '\\})').join('|'), 'ig')

	  return string.replace(regExp, match => replaces[match.substr(1, match.length - 2)] || '')
	}
}

const watch = {
  url () {
  	// console.log("URL CHANGED")
   //  console.log(this.url);
    if (this.$source) {
      this.$source.setTileUrlFunction(this.createUrlFunc())
      // console.log("Refreshed")
      this.refresh()
    }
  },
}

export default {
  mixins: [timeEnabled, source],
  props,
  computed,
  methods,
  watch,
}


// WEBPACK FOOTER //
// ./resources/js/map/MapComponents/mixins/layers/tile-source.js